
<template>
  <div class="commodity-swiper">
    <div class="container-swiper">
      <swiper class="swiImgs" :options="swiperOption" v-if="list.length != 0">
        <swiper-slide
          v-for="(item, index) in list"
          data-index="index"
          :key="index"
          class="item"
          :style="{backgroundColor:item.backGroupColor}"
        >
          <a :href="item.jumpUrl || 'javascript:;'">
            <img class="swiImg" :src="item.picUrl" />
          </a>
        </swiper-slide>
        <div
          class="swiper-pagination"
          :class="{hidden:list.length == 1}"
          v-for="(item,index) in list"
          :key="index"
          slot="pagination"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data() {
    const that = this;
    return {
      imgIndex: 1,
      swiperOption: {
        spaceBetween: 30,
        effect: "fade",
        notNextTick: true,
        loop: true,
        initialSlide: 0,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 2000,
        direction: "horizontal",
        grabCursor: true,
        on: {
          slideChangeTransitionStart: function() {
            that.imgIndex = this.realIndex + 1;
          }
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets"
        }
      }
    };
  },
  created() {
    //控制只有一张图片的时候不自动轮播
    this.swiperOption.autoplay =
      this.list.length != 1
        ? {
            delay: 2000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          }
        : false;
  },
  methods: {}
};
</script>

<style lang="less">
.commodity-swiper {
  .container-swiper {
    .swiImgs {
      .item {
        height: 288px;
        width: 100%;
        position: relative;
        a {
          display: block;
          height: 288px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          .swiImg {
            height: 288px;
          }
        }
      }
      .swiper-pagination-bullets {
        .swiper-pagination-bullet-active {
          background: #fff;
        }
      }
      .hidden {
        display: none;
      }
    }
  }
}
</style>

